/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.19"
        height="85.73"
        viewBox="0 0 82.19 85.73"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M80.95 0a1.23 1.23 0 0 1 1.24 1.12v75.94a7.34 7.34 0 0 1-.27 2.08 8.8 8.8 0 0 1-8 6.58H9.07a1.25 1.25 0 0 1-1.22-1.28 1.23 1.23 0 0 1 1.09-1.21h64.74a6.3 6.3 0 0 0 5.85-4.76 4.57 4.57 0 0 0 .16-1.1V2.5H18.01v74.1a1.25 1.25 0 0 1-1.12 1.24h-.14a1.25 1.25 0 0 1-1.24-1.12V1.25A1.24 1.24 0 0 1 16.63.01h64.32Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M44.73 11.09H28.35a1.75 1.75 0 0 0-1.75 1.75v17.1a1.75 1.75 0 0 0 1.75 1.75h16.38a1.76 1.76 0 0 0 1.72-1.75v-17.1a1.76 1.76 0 0 0-1.72-1.75Zm-.75 2.5v15.6H29.1v-15.6Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M69.85 13.79a1.24 1.24 0 0 1 1.31 1.18 1.25 1.25 0 0 1-1.18 1.32H55.65a1.25 1.25 0 0 1-1.22-1.28 1.23 1.23 0 0 1 1.09-1.21h14.33ZM69.85 27.04a1.24 1.24 0 0 1 1.22 1.27 1.26 1.26 0 0 1-1.09 1.22H55.65a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31h14.33ZM69.85 40.28a1.24 1.24 0 0 1 1.31 1.18 1.25 1.25 0 0 1-1.18 1.32H27.85a1.25 1.25 0 0 1-1.22-1.28 1.23 1.23 0 0 1 1.09-1.21h42.13ZM69.85 53.5a1.24 1.24 0 0 1 1.31 1.18A1.25 1.25 0 0 1 69.98 56H27.85a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31ZM69.85 66.77a1.24 1.24 0 0 1 1.22 1.27 1.26 1.26 0 0 1-1.09 1.22H27.85a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31h42.13ZM16.75 53.12a1.24 1.24 0 0 1 1.22 1.27 1.26 1.26 0 0 1-1.09 1.22H2.45v21a6.34 6.34 0 0 0 6.05 6.61h.49a6.2 6.2 0 0 0 6.51-6.62 1.25 1.25 0 0 1 2.5 0c0 5.63-4 9.19-9 9.12a8.82 8.82 0 0 1-9-8.64V54.41a1.24 1.24 0 0 1 1.12-1.24h15.63Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'OnePagePaperArticleIcon';

export default Icon;
